{
	"empty": "No data to display",
	"table": "Table"
}
